import Table from "Shared/components/DataTable/Table"
import restClient from "Shared/hooks/restClient"
import BookmarkedCampaigns from "./BookmarkedCampaigns"

const CampaignsDatatable = ({type = null}) => {
  const handleTableClick = (e) => {
    const button = e.target.closest('button')
    if (button && button.classList.contains('toggle-bookmark')) {
      restClient
        .put('/api/me/toggle_campaign_bookmark', { campaign_id: button.dataset.id })
        .then(reloadTable)
    }
    if (button && button.classList.contains('restore-campaign')) {
      const campaignId = button.dataset.campaignId

      if (window.confirm('Are you sure you want to restore this campaign?')) {
        restClient.post(`/api/campaigns/${campaignId}/restore`).then(() => {
          window.location.href = '/admin/campaigns'
        })
      }
    }
  }

  const tableProps = {
    table: 'campaigns',
    scope: { type },
    language: { emptyTable: 'There are no matching campaigns', searchPlaceholder: 'Search by name' },
    onClick: handleTableClick,
  }

  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload()
  }

  return (
    <>
      <BookmarkedCampaigns />

      <div className="box">
        <Table {...tableProps} />
      </div>
    </>
  )
}

export default CampaignsDatatable
